import { render, staticRenderFns } from "./ECProductList.vue?vue&type=template&id=5698f320&scoped=true&"
import script from "./ECProductList.vue?vue&type=script&lang=js&"
export * from "./ECProductList.vue?vue&type=script&lang=js&"
import style0 from "./ECProductList.vue?vue&type=style&index=0&id=5698f320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698f320",
  null
  
)

export default component.exports